import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import booksReducer from './slices/booksSlice';
import membersReducer from './slices/membersSlice';

export const store = configureStore({
    reducer: {
        user: userReducer,
        books: booksReducer,
        members: membersReducer,
    },
});
